// extracted by mini-css-extract-plugin
module.exports = {"btns":"EditorHeader_btns_WImuB","box":"EditorHeader_box_W6PxO","headerMenuBox":"EditorHeader_headerMenuBox_32L6Y","logo":"EditorHeader_logo_3T3Ow","menu":"EditorHeader_menu_d4raR"};